import React, { useEffect, useRef, useState } from 'react'
import { Gem } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import PaymentMethodSelector from '../components/PaymentMethodSelector'
import TelegramStarsPackages from '../components/TelegramStarsPackages'
import SbpPayment from '../components/SbpPayment'
import CryptoPayment from '../components/CryptoPayment'
import UzsPayment from '../components/UzsPayment'
import KztPayment from '../components/KztPayment'
import CardPayment from '../components/CardPayment'
import SkinsPayment from '../components/SkinsPayment'
import TermsAndInfo from '../../../components/TermsAndInfo'
import usePaymentStore from '../store/usePaymentStore'
import { PAYMENT_METHODS } from '../services/paymentApi'

/**
 * Payment Page
 * Главная страница пополнения баланса
 * Контейнер для выбора способа оплаты и отображения соответствующих пакетов
 */
const Payment = () => {
  const { t } = useTranslation()
  const { selectedMethod } = usePaymentStore()

  const amountTitleRef = useRef(null)
  const hasMountedRef = useRef(false)
  const [paymentMethodClickVersion, setPaymentMethodClickVersion] = useState(0)

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true
      return
    }

    if (amountTitleRef.current) {
      requestAnimationFrame(() => {
        amountTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }
  }, [paymentMethodClickVersion, selectedMethod])

  return (
    <div className="min-h-screen bg-dark-primary text-white lg:max-w-4xl lg:mx-auto">
      {/* Main Content */}
      <div className="p-6">
        {/* Title Section */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-accent-primary to-accent-secondary rounded-full flex items-center justify-center">
            <Gem size={32} className="text-dark-primary" />
          </div>
          <h1 className="text-3xl font-bold text-accent-primary mb-2">
            {t('payment.pageTitle')}
          </h1>
        </div>

        {/* Payment Method Selector */}
        <PaymentMethodSelector onMethodClick={() => setPaymentMethodClickVersion((previousValue) => previousValue + 1)} />

        {/* Package Selection Title */}
        
          <h2 ref={amountTitleRef} className="text-lg font-semibold text-white mt-8 mb-4">
            {selectedMethod !== PAYMENT_METHODS.SKINS && t('payment.selectAmount')}
          </h2>
        

        {/* Payment Method Content */}
        <div>
          {selectedMethod === PAYMENT_METHODS.TELEGRAM_STARS && (
            <TelegramStarsPackages />
          )}

          {selectedMethod === PAYMENT_METHODS.SKINS && (
            <SkinsPayment />
          )}

          {selectedMethod === PAYMENT_METHODS.UZS && (
            <UzsPayment />
          )}

          {selectedMethod === PAYMENT_METHODS.KZT1 && (
            <KztPayment />
          )}

          {selectedMethod === PAYMENT_METHODS.SBP && (
            <SbpPayment method={PAYMENT_METHODS.SBP} />
          )}

          {selectedMethod === PAYMENT_METHODS.SBP2 && (
            <SbpPayment method={PAYMENT_METHODS.SBP2} />
          )}

          {selectedMethod === PAYMENT_METHODS.CARD && (
            <CardPayment method={PAYMENT_METHODS.CARD} />
          )}

          {selectedMethod === PAYMENT_METHODS.CARDWW2 && (
            <CardPayment method={PAYMENT_METHODS.CARDWW2} />
          )}

          {selectedMethod === PAYMENT_METHODS.CARDWW1 && (
            <CardPayment method={PAYMENT_METHODS.CARDWW1} />
          )}

          {selectedMethod === PAYMENT_METHODS.CRYPTO && (
            <CryptoPayment />
          )}
        </div>
      </div>
      
      {/* Terms of Service and Company Info */}
      <TermsAndInfo />
    </div>
  )
}

export default Payment
